<template>
  <div>
    <div class="input-group" data-posthog-action="calc:zones">
      <input type="range" name="zones" min="1" max="100" v-model.number="state.zones" @keydown="clean" />
      <label>{{ pluralize(`${state.zones} DNS Zone`, state.zones) }}
        <span class="icon-question info-toggle" role="tooltip" title="A hosted zone is a collection of DNS records for a domain that may be resolved through DNSimple's name servers"></span>
      </label>
    </div>

    <div class="input-group br3" data-posthog-action="calc:queries">
      <input type="range" min="0" max="10000000" step="1000000" name="queries" v-model.number="state.queries" />
      <label>
        &lt; {{ state.queryBlocks}}m avg queries per zone / mo
        <a class="icon-info info-toggle" data-posthog-action="calc:infoOpen" href="#"
          @click.prevent="state.infoPanelOpen = true"></a>
        <em class="f4">{{ state.trafficDescriptor }}</em>
      </label>
    </div>

    <div class="input-group" data-posthog-action="calc:seats">
      <input type="range" name="seats" min="1" max="6" v-model.number="state.seats" @keydown="clean" />
      <label>
        <span>{{ pluralize(`${state.seats} Seat`, state.seats) }}</span>
        <em class="f4">1 seat included</em>
      </label>
    </div>
  </div>
</template>

<script>
import Tooltip from 'bootstrap/js/dist/tooltip';

export default {
  name: 'PricingForm',
  inject: ['state'],
  methods: {
    pluralize: (singular, num) => num === 1 ? singular : `${singular}s`
  },

  mounted () {
    Array.from(this.$el.querySelectorAll('[role="tooltip"][title]')).forEach(($el) => {
      new Tooltip($el, { title: $el.getAttribute('title') });
    });
  }

};
</script>

<style lang="scss" scoped>

@import "~/stylesheets/application/colors";

$rangeThumbSize: 20px;
$rangeThumbBg: white;
$rangeBorder: 1px solid black;

.input-group {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 1em;
  color: $gray-600;
  border-radius: .2em;
  transition: all .2s ease;
  box-sizing: border-box;

  &:nth-child(odd) {
    background: $gray-200;
  }

  label {
    line-height: 1.3em;
    display: flex;
    font-size:.9em;
    padding-left: .5em;
    flex-direction: column;
    justify-content: center;
    width: 70%;
    box-sizing: border-box;
    position: relative;

    .info-toggle {
      position: absolute;
      top: 1px;
      right: -.5em;
    }
  }

  input[type=range] {
    width: 30%;
    background-color: transparent;
    -webkit-appearance: none;
    appearance: none;

    &:focus {
      outline: none;
    }

    &::-webkit-slider-runnable-track {
      border: $rangeBorder;
      height: 0px;
    }

    &::-webkit-slider-thumb {
      -webkit-appearance: none;
      cursor: pointer;
      margin-top: - calc($rangeThumbSize/2);
      width: $rangeThumbSize;
      height: $rangeThumbSize;
      background: $rangeThumbBg;
      border: $rangeBorder;
      border-radius: $rangeThumbSize;
    }

    &::-moz-range-track {
      border: $rangeBorder;
      height: 0px;
    }

    &::-moz-range-thumb {
      width: $rangeThumbSize;
      height: $rangeThumbSize;
      background: $rangeThumbBg;
      border-radius: $rangeThumbSize;
      border: $rangeBorder;
      cursor: pointer;
    }
  }

  .user-input {
    width: 5em;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    font-weight: bold;
    border: 2px solid $gray-300;
    padding: .8em;
    border-radius: .3em;
  }
}

</style>
